import {
  ActiveStaffMembershipsQuery,
  ActiveStaffMembershipsQueryVariables,
  UpdateMyAicaDigestPreferenceMutation,
  UpdateMyAicaDigestPreferenceMutationVariables,
  UpdateUserAicaEmailPreferenceMutation,
  UpdateUserAicaEmailPreferenceMutationVariables,
} from 'types/graphql'

import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const UpdateMyAicaDigestPreferenceMutationDocument = gql`
  mutation UpdateMyAicaDigestPreferenceMutation($input: UpdateMyAicaDigestPreferenceInput!) {
    updateMyAicaDigestPreference(input: $input) {
      id
      isOptedOutFromAicaDigest
    }
  }
`

export const useUpdateMyAicaDigestPreferenceMutation = () => {
  return useMutation<
    UpdateMyAicaDigestPreferenceMutation,
    UpdateMyAicaDigestPreferenceMutationVariables
  >({
    mutationDocument: UpdateMyAicaDigestPreferenceMutationDocument,
  })
}

const ActiveStaffMembershipsQueryDocument = gql`
  query ActiveStaffMembershipsQuery($organizationId: Int) {
    activeStaffMemberships(organizationId: $organizationId) {
      ...UserOrganizationMembershipDigestFragment
    }
  }
`

export const useActiveStaffMembershipsQuery = () => {
  const organizationId = useMyOrgId()

  const { data, ...rest } = useQuery<
    ActiveStaffMembershipsQuery,
    ActiveStaffMembershipsQueryVariables
  >({
    queryKey: [QueryKey.ActiveStaffMemberships, organizationId],
    queryDocument: ActiveStaffMembershipsQueryDocument,
    variables: {
      organizationId,
    },
    enabled: !!organizationId,
  })

  return {
    ...rest,
    data: data?.activeStaffMemberships,
  }
}

const UpdateUserAicaEmailPreferenceMutationDocument = gql`
  mutation UpdateUserAicaEmailPreferenceMutation($input: UpdateUserAicaEmailPreferenceInput!) {
    updateUserAicaEmailPreference(input: $input) {
      ...UserOrganizationMembershipDigestFragment
    }
  }
`

export const useUpdateUserAicaEmailPreferenceMutation = () => {
  return useMutation<
    UpdateUserAicaEmailPreferenceMutation,
    UpdateUserAicaEmailPreferenceMutationVariables
  >({
    mutationDocument: UpdateUserAicaEmailPreferenceMutationDocument,
  })
}
